import { useEffect, useState } from "react";
import { Check, Copy, Download, ShieldCheck, Terminal } from "lucide-react";
import { api } from "../../lib/api";

let macInfoCache = null;

// Mac install: the notarized Xpattern.dmg is the one-click path; the Terminal line is the fallback.
export const MacInstall = ({ code, compact }) => {
  const [copied, setCopied] = useState(false);
  const [info, setInfo] = useState(macInfoCache);
  useEffect(() => { if (!macInfoCache) api.downloads().then((r) => { macInfoCache = r?.mac ? { available: true, ...r.mac } : { available: false }; setInfo(macInfoCache); }).catch(() => setInfo({ available: false })); }, []);
  const cmd = `curl -fsSL "${api.setupMacUrl(code)}" | bash`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(cmd); } catch { /* text is selectable */ }
    setCopied(true); setTimeout(() => setCopied(false), 2500);
  };
  const pkg = info?.available;
  const notarized = !!info?.notarized;
  return (
    <div className="space-y-2 rounded-md border border-white/10 bg-black/30 p-2.5" data-testid="mac-install">
      {pkg && (
        <div className="space-y-1">
          <a data-testid="download-mac-dmg-btn" href={api.macDmgUrl()} className="btn w-full"><Download className="h-4 w-4" /> Download Xpattern Setup (Mac)</a>
          <p className="flex items-start gap-1.5 text-[10.5px] text-[#9aa0a8]" data-testid="mac-pkg-note">
            {notarized ? <ShieldCheck className="mt-px h-3.5 w-3.5 flex-shrink-0 text-[#30d158]" /> : null}
            <span>{notarized ? "Apple-notarized — no security warnings. Open the download, double-click Xpattern Installer, and your browser opens Xpattern to pair this Mac. Plug the plotter in and it appears in the list above."
              : "Double-click the download. If macOS says it can't check it, right-click the file → Open, or go to System Settings → Privacy & Security → Open Anyway. Your browser then opens Xpattern to pair this Mac."}</span>
          </p>
          {info?.zip && <a data-testid="download-mac-zip-btn" href={`${api.macDmgUrl().replace("Xpattern.dmg", info.zip)}`} className="inline-flex items-center gap-1 text-[10px] text-[#6b7079] hover:text-[#9aa0a8] hover:underline"><Download className="h-3 w-3" /> Disk image won't open on this Mac? Download the .zip version instead — same installer.</a>}
        </div>
      )}
      <div className={pkg ? "space-y-1 border-t border-white/10 pt-2" : "space-y-1.5"}>
        <div className="flex items-center gap-2 text-[11px] font-semibold text-[#e6e8eb]"><Terminal className="h-3.5 w-3.5 text-[#4c9ffe]" /> {pkg ? "Or paste this into Terminal" : "Mac: paste this into Terminal"}</div>
        <div className="flex items-stretch gap-1.5">
          <code data-testid="mac-install-cmd" className="min-w-0 flex-1 select-all whitespace-pre-wrap break-all rounded bg-black/50 px-2 py-1.5 font-mono text-[10.5px] leading-snug text-[#9ad1ff]">{cmd}</code>
          <button type="button" data-testid="mac-install-copy-btn" onClick={copy} className={`btn shrink-0 ${copied ? "text-[#30d158]" : ""}`}>{copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}{copied ? "Copied" : "Copy"}</button>
        </div>
        {!compact && !pkg && (
          <ol className="list-decimal space-y-0.5 pl-4 text-[10.5px] text-[#9aa0a8]">
            <li>Press <b>⌘ Space</b>, type <b>Terminal</b>, press Return.</li>
            <li>Paste the line above and press Return. Enter your Mac password only if it asks.</li>
            <li>Done — the connector starts silently with your Mac and the plotter appears above within a few seconds.</li>
          </ol>
        )}
        {!pkg && <a data-testid="download-setup-mac-btn" href={api.setupMacUrl(code)} className="inline-flex items-center gap-1 text-[10px] text-[#6b7079] hover:text-[#9aa0a8] hover:underline"><Download className="h-3 w-3" /> Prefer a file? Download Xpattern-Setup.command — if double-clicking says "no appropriate access privileges", use the Terminal line instead.</a>}
      </div>
    </div>
  );
};
